Dom.addComponent(new class GradientComponent extends AbstractComponent {

  constructor() {
    super({
      name: "gradient",
      iframable: false,
      responsiveChildren: {
        width: false,
        height: false
      }
    });
  }

  css() {
    return `GULP-CSS-FILE-GRADIENT`;
  }

  html(props) {
    return `
      <div class="slaask-hidden ${props.sideClass}"></div>
    `;
  }

});
